module.exports = __webpack_public_path__ + "media/images/email-f2a9f40301fce49046e4f9b09e6fe720.svg";